import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DetailRow } from '../../ui/detail-card/payarc-detail-card.component';
import { DateonlyPipe } from '../../shared/custom-pipes/date-format-pipe/dateonly.pipe';

@Component({
    selector: 'app-api-token',
    templateUrl: './api-token.component.html',
    styleUrls: ['./api-token.component.css'],
    standalone: false
})
export class ApiTokenComponent {
  readonly detailRows: DetailRow[];
  private readonly dateonly = new DateonlyPipe();

  constructor(
    private dialog: MatDialogRef<ApiTokenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { token: string, item: any }
  ) {
    this.detailRows = [
      { label: 'ID', value: data.item.id },
      { label: 'Client ID', value: data.item.client_id },
      { label: 'Client secret', value: data.item.client_secret || '--' },
      { label: 'Use count', value: data.item.use_count ?? '--' },
      { label: 'Last used', value: data.item.last_used ? this.dateonly.transform(data.item.last_used, 'MM/DD/yyyy') : '--' },
      { label: 'Expiry date', value: data.item.expires_at ? this.dateonly.transform(data.item.expires_at, 'MM/DD/yyyy') : '--' },
    ];
  }

  closeAction() {
    this.dialog.close('cancel');
  }

  copy(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    const tooltip = document.getElementById('myTooltip');
    tooltip.innerHTML = 'Copied';
  }
}
